import { useSelectedProcessesIdsForGroup } from "components/Dashboard/Tiles/GroupTile/GroupTile";
import { UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES } from "providers/GlobalStateProvider";
import DataDumpGetter from "segments/DataDumpGetter/DataDumpGetter";
import { useFocusRange } from "utils/customHooks/genericHooks";

export function DataDumpGetterForOneGroupTile({
  shortName,
  processes,
  summaryGroup,
}) {
  const focusRange = useFocusRange();
  const selectedProcessIdsForGroup = useSelectedProcessesIdsForGroup(
    shortName,
    processes
  );
  return (
    <DataDumpGetter
      timeRange={focusRange}
      processIds={selectedProcessIdsForGroup}
      dataDumpAggType={UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES}
      additionalPayload={{ summaryGroup }}
    />
  );
}
